import { StafferPetSafetyBoundary } from "./StafferPetSafetyBoundary";
import { StafferPetSprite } from "./StafferPetSprite";
import { stafferPets } from "../../lib/stafferPets";
import type { Pet } from "../../types";

export const StafferPetProfileSprite = ({
  pet,
  sizePx,
  className,
  isAnimated,
  isBouncing,
  isTripleBounce,
  isOnLeaderboard = false,
}: {
  pet: Pet | null | undefined;
  sizePx?: number;
  className?: string;
  isAnimated?: boolean;
  isBouncing?: boolean;
  isTripleBounce?: boolean;
  // A crowned pet set to "leaderboard only" shows the crown just here.
  isOnLeaderboard?: boolean;
}) => {
  /* Render */
  const render = () => {
    if (!pet) return null;
    // Server-derived from the leaderboard; species without evolved art ignore it.
    const isEvolved = pet.isEvolved ?? false;
    const topperId = stafferPets.getWornTopperId(pet, { isOnLeaderboard });

    return (
      <StafferPetSafetyBoundary>
        <StafferPetSprite
          species={pet.equipped.petId}
          paletteId={pet.equipped.colorId}
          sizePx={sizePx}
          className={className}
          isAnimated={isAnimated}
          isBouncing={isBouncing}
          isTripleBounce={isTripleBounce}
          isEvolved={isEvolved}
          topperId={topperId}
          topperOffset={stafferPets.getTopperOffset(
            pet.topperOffsets,
            pet.equipped.petId,
            topperId,
            isEvolved,
          )}
          accessoryId={pet.equipped.accessoryId}
          accessoryAdjustment={stafferPets.getAccessoryAdjustment(
            pet.accessoryAdjustments,
            pet.equipped.petId,
            pet.equipped.accessoryId,
            isEvolved,
          )}
          accessoryId2={pet.equipped.accessoryId2}
          accessoryAdjustment2={stafferPets.getAccessoryAdjustment(
            pet.accessoryAdjustments,
            pet.equipped.petId,
            pet.equipped.accessoryId2,
            isEvolved,
          )}
        />
      </StafferPetSafetyBoundary>
    );
  };

  return render();
};
